<template>
  <dl :class="classes">
    <template v-if="$store.getters['config/isManabi']">
      <template v-if="id === 'seiseki'">
        <dt class="dn-gnavi__category-name" @click="toggle">
          <span v-html="label"></span>
          <span class="dn-icon dn-icon-arrow-down is-white"></span>
        </dt>
        <dn-expand-transition>
          <dd class="dn-gnavi__category-body" v-show="opend">
            <template
              v-for="group in computedGroups"
            >
              <span
                v-if="group.label"
                :key="group.id + '-label'"
                v-html="group.label"
                class="dn-gnavi__link dn-gnavi__label"
              ></span>

              <a
                v-for="link in group.links"
                :key="link.id"
                class="dn-gnavi__link"
                :class="{
                  'dn-gnavi__link--auth': link.auth,
                  'dn-gnavi__link--matched': link.matched,
                  'dn-gnavi__link--index-matched': (link.data.groupIndex || link.data.groupIndex === '') && link.group.matched,
                }"
                :href="link.href"
                :target="link.target"
                v-linkset="link.url_id"
              >
                <i class="dn-gnavi__link__bg"></i>
                <span class="dn-gnavi__text" v-html="link.label"></span>
                <span class="dn-icon dn-icon-arrow-right"></span>
              </a>
            </template>
          </dd>
        </dn-expand-transition>
      </template>
      <template v-else-if="id === 'TOP' || id==='myuniv_bible' || id==='exam_bible' || id === 'self_check'">
        <dt class="dn-gnavi__category-name" style="position:relative;">
          <span v-html="label"></span>
        </dt>
      </template>
      <template v-else-if="id === 'manabi' || 'dn'">
        <dt class="dn-gnavi__category-name">
          <span v-html="label"></span>
        </dt>
      </template>
    </template>
    <template v-else>
    <dt class="dn-gnavi__category-name" @click="toggle">
      <span v-html="label"></span>
      <span class="dn-icon dn-icon-arrow-right is-white"></span>
      <span class="dn-icon dn-icon-arrow-up is-white"></span>
    </dt>
    <dn-expand-transition>
      <dd class="dn-gnavi__category-body" v-show="opend">
        <template
          v-for="group in computedGroups"
        >
          <span
            v-if="group.label"
            :key="group.id + '-label'"
            v-html="group.label"
            class="dn-gnavi__link dn-gnavi__label"
          ></span>

          <a
            v-for="link in group.links"
            :key="link.id"
            class="dn-gnavi__link"
            :class="{
              'dn-gnavi__link--auth': link.auth,
              'dn-gnavi__link--matched': link.matched,
              'dn-gnavi__link--current': link.current,
              'dn-gnavi__link--index-matched': (link.data.groupIndex || link.data.groupIndex === '') && link.group.matched,
            }"
            :href="link.href"
            :target="link.target"
            v-linkset="link.url_id"
          >
            <i class="dn-gnavi__link__bg"></i>
            <span class="dn-gnavi__text" v-html="link.label"></span>
            <span class="dn-icon dn-icon-arrow-right"></span>
          </a>
        </template>
      </dd>
    </dn-expand-transition>
    </template>
  </dl>
</template>


<script>
export default {
  name: 'dn-gnavi-inner',

  props: {
    id: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    groups: {
      type: Array,
      required: true,
    },
    disabled: Boolean,
    default: Boolean,
    value: Boolean,
  },

  data() {
    return {
      innerValue: this.value,
    }
  },

  computed: {
    classes() {
      return {
        'dn-gnavi__category': true,
        'dn-gnavi__category--default': this.default,
        'dn-gnavi__category--disabled': this.disabled,
        'dn-gnavi__category--open': this.opend,
        [`dn-gnavi__category--${this.id}`]: true,
      }
    },

    computedGroups() {
      const groups = [];
      this.groups.forEach(group => {
        const links = group.links.filter(link => {
          return (!link.data.gnaviIgnore && link.data.gnaviIgnore !== '');
        });
        if (links.length > 0) {
          groups.push(Object.assign({}, group, { links }));
        }
      });
      return groups;
    },

    opend: {
      get() { return this.innerValue },
      set(val) {
        this.innerValue = val;
        this.$emit('input', val);
      },
    },
  },

  watch: {
    value(val) {
      this.innerValue = val;
    },
  },

  methods: {
    toggle() {
      if (this.disabled) return;
      this.opend = !this.opend;
    },
  },
}
</script>



// WEBPACK FOOTER //
// GnaviCategory.vue?60573476